import { Component, OnInit, Input } from '@angular/core';
import { Center } from 'src/app/models/center-model/center.model';
import { Rol } from 'src/app/models/roles-models/rol.model';
import { UserService } from 'src/app/services/user-service/user.service';
import { RolBasic } from 'src/app/models/roles-models/rol-basic.model';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-users-new-user-new-role-creation-card',
  templateUrl: './users-new-user-new-role-creation-card.component.html',
  styleUrls: ['./users-new-user-new-role-creation-card.component.scss']
})
export class UsersNewUserNewRoleCreationCardComponent implements OnInit {

  @Input() centers;
  @Input() roles;
  selectedRoles;
  selectedCenters;
  showButton: boolean;
  basicDataForm = new FormGroup({
    selectedRole: new FormControl(null)
  });

  constructor(private userService: UserService,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
                this.showButton = true;
                this.selectedCenters = new Array<Center>();
                this.selectedRoles = new Array<Rol>();
  }

  ngOnInit() { }

  public addNewPermission() {
    const validation = this.validateForm();
    if (validation === true) {
      this.selectedCenters.forEach(
        (c) => {
          const permission = new RolBasic();
          permission.CenterInternalId = c.InternalId;
          permission.CenterName = c.CenterName;
          permission.RoleInternalId = this.basicDataForm.get('selectedRole').value.RoleInternalId;
          permission.RoleName = this.basicDataForm.get('selectedRole').value.Rolename;
          this.userService.rememberPermission(permission);
        }
      );
      this.router.navigate(['../../user'], { relativeTo: this.activatedRoute.parent });
    }
  }

  public cancelPermission() {
    this.router.navigate(['../../user'], { relativeTo: this.activatedRoute.parent });
  }

  public centersOutputEventReceiver(centers) {
    const aux = new Array();
    for (const d of centers) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedCenters = aux;
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('selectedRole').valid) {
      return 'users-page.snackbar messages.role required';
    } else {
      return true;
    }
  }
  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

}
